module.exports = __webpack_public_path__ + "img/student8.915164ba.png";